import React, { useState, useEffect } from 'react'
import swal from '@sweetalert/with-react'
import { swalMessages } from '@auteco/constants'
import { Button, Card, Typography } from '@material-ui/core'
import CardTitle from '@auteco/components/sharedComponents/CardTitle'

import {
  getProfiles,
  postMaterials,
  getMaterialsNoGroup,
  getFilters,
  getMaterialsGroups,
  getRolUser,
  getMaterialsList,
} from '@auteco/services/snopServices'
import { CreateGroupTable } from './components/CreateGroupTable'
import { RelateSection } from './components/RelateSection'
import { MaterialsFilters } from '../MaterialsFilters'
import useStyles from './styles'

const CreateGroups = () => {
  const [filters, setFilters] = useState([])
  const [materials, setMaterials] = useState([])
  const [page, setPage] = useState('assign')
  const [profiles, setProfiles] = useState([])
  const [infoBars, setInfoBars] = useState({})
  const [loading, setLoading] = useState(false)
  const [groups, setGroups] = useState([])
  const [materialsList, setMaterialsList] = useState([])

  const [isChecked, setIsChecked] = useState(true)

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked)
  }

  const getMaterialsListApi = async () => {
    const response = await getMaterialsList()
    setMaterialsList(response.grupos)
    console.log(response, 'response')
  }

  const getGroups = async () => {
    setLoading(true)
    try {
      const { grupos } = await getMaterialsGroups()
      console.log(grupos)
      if (grupos) {
        setGroups(grupos)
        console.log(grupos)
      } else {
        setGroups([])
      }
    } catch (error) {
      console.error('Error fetching groups:', error)
      setGroups([])
    }
    setLoading(false)
  }

  const getInfoBars = async () => {
    setLoading(true)
    const response = await getRolUser()
    if (response) {
      console.log(response)
      setInfoBars(response.iam.nombre)
    }
    setLoading(false)
  }

  const classes = useStyles()

  const getFiltersApi = async () => {
    setLoading(true)
    const { data } = await getFilters()
    setFilters(data)
    setLoading(false)
  }

  const handleGetProfiles = async () => {
    setLoading(true)
    const { perfiles } = await getProfiles()
    await getMaterialsListApi()

    if (perfiles) {
      setProfiles(perfiles)
    }
    setLoading(false)
  }

  const onFilter = async ({ form }) => {
    setLoading(true)
    try {
      const data = await postMaterials({ params: form })
      console.log(data, 'succes data')
      if (data) {
        console.log(data)
        if(isChecked){
         const listaFiltrada = (data.data).filter(item => !Object.prototype.hasOwnProperty.call(item, 'gnombre'));
         setMaterials(listaFiltrada)
        }else{
          setMaterials(data.data)
        }
      } else {
        setMaterials([])
        swal(swalMessages.GENERAL_ERROR)
      }
    } catch (error) {
      console.error('Error filtering materials:', error)
      setMaterials([])
      swal(swalMessages.GENERAL_ERROR)
    }
    setLoading(false)
  }

  const getUnassignedMaterials = async () => {
    setLoading(true)
    try {
      const data = await getMaterialsNoGroup()
      if (data) {
        console.log(data, 'materials')
        setMaterials(data)
      } else {
        setMaterials([])
        swal(swalMessages.GENERAL_ERROR)
      }
    } catch (error) {
      console.error('Error fetching unassigned materials:', error)
      setMaterials([])
      swal(swalMessages.GENERAL_ERROR)
    }
    setLoading(false)
  }

  // const getUnassignedMaterials = () => {
  //   onFilter({ form: initialForm })
  // }

  const onSelectPage = ({ value }) => {
    setMaterials([])
    setPage(value)
  }

  useEffect(() => {
    getFiltersApi()
    handleGetProfiles()
    getInfoBars()
    getGroups()
  }, [])

  if (infoBars && infoBars !== 'Gerente') {
    return <p>Permisos insuficientes</p>
  }



  return (
    <>
      <Card className={classes.container}>
        <CardTitle
          title="Grupos y perfiles"
          subTitle="Asignar materiales, vincular, crear, eliminar grupos y perfiles"
        />
        <div className={classes.mainContainerBtns}>
          <div className={classes.containerBtns}>
            <Button
              disabled={loading}
              variant="contained"
              className={page === 'assign' ? classes.selectedBtn : classes.btn}
              onClick={() => onSelectPage({ value: 'assign' })}
            >
              Grupos
            </Button>
            <Button
              variant="contained"
              disabled={loading}
              className={page === 'relate' ? classes.selectedBtn : classes.btn}
              onClick={() => onSelectPage({ value: 'relate' })}
            >
              Perfiles
            </Button>
          </div>
        </div>
        {page === 'assign' && (
          <Card className={classes.cardSection}>
            {filters.length > 0 ? (
              <>
                <MaterialsFilters
                  loading={loading}
                  filters={filters}
                  onFilter={onFilter}
                />
                <label htmlFor="filter-checkbox">
                  <input
                    id="filter-checkbox"
                    type="checkbox"
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                  />
                  Filtrar materiales sin grupo
                </label>
              </>
            ) : (
              <h4 style={{ padding: '20px' }}>Cargando ⏳</h4>
            )}
            <>
              <Card className={classes.unassignedCard}>
                <Typography className={classes.unassignedTitle}>
                  Materiales sin grupos
                </Typography>
                <Typography>
                  Busca los materiales que aún no tienen un grupo asignado
                </Typography>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.unassignedBtn}
                  onClick={getUnassignedMaterials}
                  disabled={loading}
                >
                  Buscar
                </Button>
              </Card>

              <CreateGroupTable
                setLoading={setLoading}
                loading={loading}
                materials={materials}
                getUnassignedMaterials={getUnassignedMaterials}
                groups={groups}
                getGroups={getGroups}
              />
            </>
          </Card>
        )}{' '}
        {page === 'relate' && (
          <Card className={classes.cardSection}>
            <RelateSection
              profiles={profiles}
              getProfiles={handleGetProfiles}
              materialsList={materialsList}
              setMaterialsList={setMaterialsList}
              getMaterialsListApi={getMaterialsListApi}
            />
          </Card>
        )}
      </Card>
    </>
  )
}

export { CreateGroups }
